import React, { useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import Clickable from 'components/Common/Clickable'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import FlightDealModal from './FlightDealModal'
import OfferCalendarFlightDealBannerCountdown from '../Filters/CalendarPicker/OfferCalendarFlightDealBannerCountdown'

interface Props {
  activeDeal: App.FlightDeal
  showCountdown?: boolean
}

function FlightDealLabel(props: Props) {
  const { activeDeal, showCountdown = true } = props
  const showModal = useContext(ModalContext)

  const handleOpenFlightDealModal = () => {
    showModal(<FlightDealModal activeDeal={activeDeal} />)
  }

  return (
    <Clickable onClick={handleOpenFlightDealModal}>
      <UrgencyLabel
        icon={<SolidFireIcon />}
        variant="critical2"
        endIcon={showCountdown ? <LineInfoCircleIcon /> : undefined}
      >
        {showCountdown && (
          <>
            Flight sale ends in{' '}
            <OfferCalendarFlightDealBannerCountdown salesEndDate={activeDeal.salesEndDate} />
          </>
        )}
        {!showCountdown && 'Flight sale'}
      </UrgencyLabel>
    </Clickable>
  )
}

export default FlightDealLabel
